import React, { useState } from "react";
import PropTypes from "prop-types";

import { MDBIcon } from 'mdb-react-ui-kit';

function Accordion({ title, description }) {
  const [isActive, setActive] = useState(false);
  const handleClick = () => setActive(!isActive);

  return (
    <div className="accordion__item">
      <div className="accordion__title-wrapper" onClick={handleClick}>
        <h2 className="accordion__title">{title}</h2>
        {isActive ? <MDBIcon fas icon="minus" style={{cursor:"pointer"}}/> : <MDBIcon fas icon="plus" style={{cursor:"pointer"}}/>}
      </div>
      {isActive && <p className="accordion__description">{description}</p>}
    </div>
  );
}

// PropTypes validation for React JS
Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Accordion;
